<template>
    <v-ons-page>
        <div v-if="hasEarnedTrips" class="page-header">
            <img src="../assets/hynds-vip.svg" width="74px" style="width:74px;" class="logo">
        </div>
        <div v-show="initialized">

            <template v-if="!hasEarnedTrips">
                <div class="copy text-center mt-4 copy--trips">
                    <div class="placeholder-icon">
                        <img src="../assets/no-trips.svg" class="mb-2" width="274px" style="width:274px;">
                    </div>
                    <h1>You haven't earned any <br>trips yet</h1>
                    <p class="intro">
                        Have your passport ready though.<br>
                        To check your progress return to <br>the dashboard
                    </p>
                    <v-ons-row>
                        <v-ons-col class="content-col">
                            <v-ons-button @click="$router.push({ name: 'home' })"
                                class="button button--primary">
                                Return to Dashboard
                            </v-ons-button>
                        </v-ons-col>
                    </v-ons-row>
                </div>
            </template>
            <template v-else>
                <div class="copy text-center">
                    <p class="intro">These are the trips you have already earned.</p>
                </div>

                <v-ons-row>
                    <v-ons-col>
                        <div class="mt-2 mb-3">
                            <h2>You have <strong>{{ earnedTrips.length }} earned</strong> trip{{ earnedTrips.length > 1 ? 's' : '' }}:</h2>
                        </div>
                        <v-ons-card v-for="trip in earnedTrips"
                            :key="trip.id">
                            <div class="card__image">
                                <a href="javascript:void(0)" @click="goToTrip(trip)">
                                    <img :src="imgPath(_.get(trip, 'attributes.image'))"
                                        :alt="_.get(trip, 'attributes.image.name')">
                                </a>
                                <span class="card__image__year">{{ _.get(trip, 'attributes.year')}}</span>
                                <div v-if="_.get(trip, 'attributes.trip_type') == 'Gold'" class="card__persons">
                                    <div class="person-icon">
                                        <span class="person-count">{{ _.get(trip, 'attributes.pax') }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="title" @click="goToTrip(trip)">
                                {{ _.get(trip, 'attributes.name') }}
                            </div>
                            <div class="content" @click="goToTrip(trip)">
                                <div class="progress-container">
                                    <span>Your progress</span>
                                    <em v-if="_.get(trip, 'attributes.percentage') >= 100" class="progress-note text-success">Trip earned!</em>
                                    <em v-else-if="_.get(trip, 'attributes.percentage') >= 90" class="progress-note text-success">Nearly there!</em>

                                    <span>{{ _.get(trip, 'attributes.trip_type') == 'Gold' ? _.get(trip, 'attributes.percentage')+'%' : '$'+_.get(trip, 'attributes.percentage')+'K' }}</span>
                                </div>
                                <v-ons-progress-bar :value="_.get(trip, 'attributes.percentage')"></v-ons-progress-bar>

                                <p class="intro" v-if="_.get(trip, 'attributes.intro')">{{ _.get(trip, 'attributes.intro') }}</p>

                            </div>
                        </v-ons-card>

                        <v-ons-row class="mb-4">
                            <v-ons-col class="content-col">
                                <v-ons-button @click="$router.push({ name: 'home' })"
                                    class="button button--primary">
                                    Return to Dashboard
                                </v-ons-button>
                            </v-ons-col>
                        </v-ons-row>

                    </v-ons-col>
                </v-ons-row>
            </template>
        </div>
        <div v-show="!initialized" class="text-center page-progress-loader">
            <v-ons-progress-circular
                indeterminate
                ></v-ons-progress-circular>
        </div>

    </v-ons-page>
</template>

<script>
import Utils from './mixins/Utils'
import Module from './mixins/Module'

export default {
    data () {
        return {
            initialized: false,
            currentTrip: null,
        }
    },
    created() {
        this.$emit('init', {
            name: 'trips',
            title: 'Your Trips',
            showMenu: true,
            showFooter: false,
        })

        if (!this.customer.content.id) {
            return this.$router.push('login')
        }

        this.trips.getInitialData('/my/all_trips', {
            token: this.getToken(),
        }).then((trips) => {
            this.currentTrip = _.find(trips.data, (t) => {
                return _.get(t, 'attributes.redeemed_customer_id');
            })
        })

        // let pageId = this.$route.params.id;
        this.page.getInitialData(`/pages/15`, {
            token: this.getToken(),
        }).then((res) => {
            this.$emit('init', {
                name: 'page',
                title: 'Your Trips',
                showMenu: true,
            })
            this.initialized = true;
        })
    },

    mixins: [
        Utils,
        Module('customer'),
        Module('trips'),
        Module('page'),

    ],
    computed: {
        pageData() {
            return _.get(this.page, 'content') || {}
        },
        customerPax() {
            return _.get(this.customer, 'content.attributes.persons')
        },
        currentYear() {
            return new Date().getFullYear();
        },
        earnedTrips() {
            let trips = this.trips.content.data;

            return _.filter(trips, (trip) => {
                return trip.attributes.percentage >= 100;
            });
        },
        hasEarnedTrips() {
            return this.earnedTrips.length > 0;
        },
    },
    methods: {
        goToTrip(trip) {
            // if (!this.getTripStatus(trip)) {
            //     return false;
            // }

            this.$router.push({
                name: 'trip',
                params: {
                    id: trip.id
                }
            })
        },

        getTripStatus(trip) {
            if (this.currentTrip && trip.id == this.currentTrip.id) {
                return true;
            }

            return false;
        },

    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.logo {
    margin-bottom: 6px;
}
.placeholdericon {
    padding: 16px 32px;
}
.copy--trips{
    padding: 16px 8px;
}
img {
    width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/TripsPage.vue